import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {GlobalWindow} from '@/types';

export class QueryStringService {
  private readonly keys = {
    authScenario: 'auth_scenario',
    mobileVersion: 'mbversion',
    auth: 'auth',
    platform: 'platform',
    httpCode: 'http_code',
    errorCode: 'error_code',
  };

  constructor(private readonly globalWindow: GlobalWindow) {}

  public getQueryValue(key: string): string | null {
    return new this.globalWindow.URL(this.globalWindow.location.href).searchParams.get(key);
  }

  public dataToSearchParams(query: Record<string, string | undefined | null | number> = {}): URLSearchParams {
    const searchParams = new URLSearchParams();

    Object.entries(query).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value.toString());
      }
    });

    return searchParams;
  }

  public getAuthScenario(): string | null {
    return this.getQueryValue(this.keys.authScenario);
  }

  public getMobileVersion(): string | null {
    return this.getQueryValue(this.keys.mobileVersion);
  }

  public getAuth(): string | null {
    return this.getQueryValue(this.keys.auth);
  }

  public getPlatform(): string | null {
    return this.getQueryValue(this.keys.platform);
  }

  public getHttpCode(): string | null {
    return this.getQueryValue(this.keys.httpCode);
  }

  public getErrorCode(): string | null {
    return this.getQueryValue(this.keys.errorCode);
  }
}

injected(QueryStringService, DI_TOKENS.globalWindow);
